/***********************
 * ALERT CHART COLORS
 ************************/

// Small category chart
const alertsChartColors = {
  activity: {
    fill: [
      "#37482a",
      "#455a34",
      "#526c3f",
      "#607d49",
      "#7ca25e",
      "#8ab469",
      "#adca96",
    ],
    label: ["#00000063"],
  },
  ab: {
    fill: ["#c4ab4f", "#dcc059", "#f5d663", "#f8e291"],
    label: ["#00000063"],
  },
  health: {
    fill: [
      "#37482a",
      "#455a34",
      "#526c3f",
      "#607d49",
      "#7ca25e",
      "#8ab469",
      "#adca96",
    ],
    label: ["#00000063"],
  },
  devices: {
    fill: [
      "#1b3650",
      "#1e3d5a",
      "#224465",
      "#385674",
      "#4e6983",
      "#647c93",
      "#7a8ea2",
      "#7fa3c7",
      "#748ea8",
      "#8b959e",
      "#91a7bd",
      "#b1b6ba",
      "#172f46",
      "#14283c",
    ],
    label: ["#00000063"],
  },
  safety: {
    fill: [
      "#5c6c60",
      "#6e8273",
      "#809787",
      "#93ad9a",
      "#a5c3ad",
      "#b8d9c1",
      "#bfdcc7",
      "#c6e0cd",
      "#cde4d3",
      "#dbece0",
    ],
    label: ["#00000063"],
  },
  apartment: {
    fill: [
      "#3291ad",
      "#39a6c6",
      "#40bbdf",
      "#48d0f8",
      "#5ad4f8",
      "#a3e7fb",
      "#4d9db3",
      "#63afc2",
      "#79c1d1",
    ],
    label: ["#00000063"],
  },
  other: {
    fill: ["#8E7199", "#9B82A3", "#A993AD", "#B7A4B7", "#C5B5C1", "#D3C6CB"],
    label: ["#00000063"],
  },
}

export { alertsChartColors }
